import $ from 'jquery';
import 'slick-carousel';

const FeatureSlider = () => {
  const textImgCarousel = $('.feature-gallery-contain');

  textImgCarousel.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    arrows: false,
    cssEase: 'linear',
    draggable: false,
    autoplay: false,
    speed: 800,
  });

  // ticking machine
  let percentTime;
  let tick;
  const time = 1;
  let progressBarIndex = 0;

  $('.progressBarContainer .progressBar__bar').each(function (index) {
    const progress = `<div class='inProgress inProgress${index}'></div>`;
    $(this).html(progress);
  });

  function startProgressbar() {
    resetProgressbar();
    percentTime = 0;
    tick = setInterval(interval, 10);
  }

  function interval() {
    if (
      $(
        `.feature-gallery-contain .slick-track div[data-slick-index="${progressBarIndex}"]`
      ).attr('aria-hidden') === 'true'
    ) {
      progressBarIndex = $(
        '.feature-gallery-contain .slick-track div[aria-hidden="false"]'
      ).data('slickIndex');
      startProgressbar();
    } else {
      percentTime += 1 / (time + 5);
      $(`.inProgress${progressBarIndex}`).css({
        width: `${percentTime}%`,
      });
      $('.progressBar--active').removeClass('progressBar--active');
      $(`.inProgress${progressBarIndex}`)
        .parent()
        .parent()
        .addClass('progressBar--active');
      if (percentTime >= 100) {
        $(`.inProgress${progressBarIndex}`)
          .parent()
          .parent()
          .removeClass('progressBar--active');
        $('.feature-gallery-contain').slick('slickNext');
        progressBarIndex++;
        if (progressBarIndex > 2) {
          progressBarIndex = 0;
        }
        startProgressbar();
      }
    }
  }

  function resetProgressbar() {
    $('.inProgress').css({
      width: `${0}%`,
    });
    clearInterval(tick);
  }
  startProgressbar();
  // End ticking machine

  $('.progressBarContainer .progressBar').click(function () {
    clearInterval(tick);
    $('.progressBar--active').removeClass('progressBar--active');
    $(`.progressBar ${goToThisIndex}`).addClass('progressBar--active');
    var goToThisIndex = $(this).find('span').data('slickIndex');
    $('.feature-gallery-contain').slick('slickGoTo', goToThisIndex, false);
    startProgressbar();
  });
};

export default FeatureSlider;
